import { type FC } from "react";
import { FormattedMessage } from "react-intl";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import { useUser } from "@packsize/authentication";

import { InfoRow } from "./info-row";

export const LegacyFeatureFlagsCard: FC = () => {
	const { currentUser } = useUser();

	if (currentUser == null) {
		return null;
	}

	const legacyFlags = Object.entries(currentUser.featureFlags).filter(([, value]) => value === "True");

	return (
		<Card id="developer-legacy-feature-flags">
			<CardContent>
				<Typography variant="h3" component="h2" gutterBottom>
					<FormattedMessage id="Legacy Feature Flags" defaultMessage="Legacy Feature Flags" />
				</Typography>
				<Stack spacing={2}>
					{legacyFlags.map(([key]) => (
						<InfoRow key={key} label={key} value="true" />
					))}
				</Stack>
			</CardContent>
		</Card>
	);
};
